import { theme } from "../settings/config"

// Le iniziali di nome e cognome: "Luca Morosini" fa "LM", e con `count` a 1
// solo quella del nome, "L"
export const coachInitials = (name, count = 2) =>
	(name ?? "")
		.split(" ")
		.filter(Boolean)
		.slice(0, count)
		.map(word => word[0].toUpperCase())
		.join("")

// Il maestro in un tondo: la sua foto, o senza foto le sue iniziali. Il
// nome ce l'ha sempre accanto chi lo mostra, quindi il tondo per uno screen
// reader non dice niente.
//
// `initials` dice quante lettere: due di solito, una dove il tondo è il
// proprio, nella barra in basso.
//
// `muted` è chi nel circolo non insegna: un tondo grigio, come una sedia
// vuota in agenda. Con la foto la foto resta com'è: la differenza la dice
// la scritta accanto.
function CoachAvatar({ coach, size = 40, muted = false, initials = 2, style }) {
	const photo = coach?.photo

	return (
		<span
			aria-hidden="true"
			style={{
				width: `${size}px`,
				height: `${size}px`,
				flexShrink: 0,
				borderRadius: "50%",
				overflow: "hidden",
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "center",
				boxSizing: "border-box",
				background: muted ? theme.colors.gray_light : theme.colors.gunmetal_lighter,
				color: muted ? theme.colors.text_light : theme.colors.gunmetal,
				fontWeight: 700,
				fontSize: `${Math.round(size * 0.38)}px`,
				lineHeight: 1,
				userSelect: "none",
				...style,
			}}>
			{photo ? (
				<img
					src={photo}
					alt=""
					draggable={false}
					style={{
						width: "100%",
						height: "100%",
						objectFit: "cover",
						pointerEvents: "none",
					}}
				/>
			) : (
				coachInitials(coach?.coachName, initials)
			)}
		</span>
	)
}

export default CoachAvatar
